import { Link } from 'react-router-dom';

// Política de Privacidad — borrador completo (2026-09-16).
// Contexto: Venezuela. Redactada genéricamente para adaptación por asesoría legal.
// Marcadores [NOTA LEGAL: ...] y [PERIODO POR DEFINIR] señalan decisiones pendientes.
// Los hechos técnicos descritos (bcrypt, tokens con hash, Resend, verificación 24h,
// OTP 6 dígitos/10 min, soft-delete con email como lápida) reflejan la implementación
// actual; no se afirman características inexistentes (sin analítica, sin marketing por email).

const BANNER = (
  <div className="mb-8 rounded-xl border-2 border-dashed border-amber-400 bg-amber-50 px-4 py-3 text-sm text-amber-800">
    <strong>BORRADOR — pendiente de revisión legal.</strong> Este documento es un
    borrador de trabajo genérico; no constituye asesoría legal y debe ser revisado
    y adaptado por un profesional del derecho antes de considerarse definitivo.
  </div>
);

export default function PrivacyPolicy() {
  return (
    <div className="min-h-full bg-white">
      {/* Header */}
      <header className="border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center gap-2">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
                <rect width="40" height="40" rx="10" fill="#36CCD8"/>
                <path d="M20 8L6 22L12 28L20 20L28 28L34 22L20 8Z" fill="white"/>
                <path d="M20 16L12 24L16 28L20 24L24 28L28 24L20 16Z" fill="white" fillOpacity="0.4"/>
              </svg>
              <span className="text-xl font-bold text-gray-900">Vecindus</span>
            </Link>
            <Link
              to="/login"
              className="px-4 py-2 text-[#36CCD8] font-semibold hover:text-[#2DB8C4] transition-colors"
            >
              Iniciar sesión
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {BANNER}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Política de Privacidad</h1>
        <p className="text-sm text-gray-500 mb-6">Responsable del tratamiento: Jaime del Val Martin · Contacto: info@vecindus.com</p>
        <p className="text-sm text-gray-500 mb-8">
          Última actualización: Septiembre 2026 (borrador).{' '}
          <Link to="/terminos" className="text-[#36CCD8] hover:text-[#2DB8C4] underline underline-offset-2 font-medium">
            Consulta también nuestros Términos y Condiciones →
          </Link>
        </p>

        <div className="prose prose-slate max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Introducción</h2>
            <p className="text-gray-600 mb-4">
              Esta Política de Privacidad describe cómo Vecindus (&laquo;Vecindus&raquo;, &laquo;nosotros&raquo;)
              recopila, utiliza, conserva y comparte la información personal de los usuarios de la
              plataforma de gestión de condominios y control de accesos, incluidos administradores,
              residentes, familiares, personal de seguridad y datos de visitantes registrados.
            </p>
            <p className="text-gray-600">
              En los casos en que un condominio carga datos de sus residentes y visitantes,
              el condominio actúa como responsable del tratamiento y Vecindus como encargado del
              tratamiento que procesa dichos datos en su nombre.{' '}
              <em>[NOTA LEGAL: precisar la calificación de roles (responsable/encargado) conforme a
              la normativa venezolana y del prestador.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Datos que recopilamos</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>
                <strong>Datos de cuenta:</strong> nombre completo, dirección de correo electrónico,
                número de teléfono, contraseña (almacenada únicamente como hash cifrado con bcrypt,
                nunca en texto plano).
              </li>
              <li>
                <strong>Datos de residencia:</strong> condominio, unidad habitacional asignada y rol
                (propietario, inquilino, familiar, personal de seguridad, proveedor).
              </li>
              <li>
                <strong>Datos de acceso y seguridad:</strong> pases QR emitidos, invitaciones de
                visitantes, registro de ingresos de visitantes (incluyendo nombre, placa del
                vehículo cuando aplique, fecha y hora de entrada y salida) y bitácoras de accesos.
              </li>
              <li>
                <strong>Datos técnicos de operación:</strong> registros necesarios para el
                funcionamiento del servicio (por ejemplo, verificación de correo y códigos de
                seguridad). <em>No utilizamos herramientas de analítica de terceros ni enviamos
                correos de marketing.</em>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Finalidades del tratamiento</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Prestar el servicio de gestión del condominio y control de accesos.</li>
              <li>Gestionar invitaciones, aprobaciones y registro de visitantes.</li>
              <li>Proteger la seguridad de las cuentas: verificación de correo mediante enlaces de
                un solo uso (vigencia de 24 horas) y códigos OTP de 6 dígitos con expiración de 10
                minutos.</li>
              <li>Operar el servicio: autenticación, facturación de suscripciones y soporte.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Bases legales</h2>
            <p className="text-gray-600">
              Tratamos tus datos, de forma enunciativa, sobre las siguientes bases: (i) ejecución
              del contrato con el condominio o contigo (prestación del servicio); (ii) interés
              legítimo en la seguridad de las cuentas y de las instalaciones (control de accesos y
              prevención de fraudes); (iii) cumplimiento de obligaciones legales (conservación de
              registros contables o de facturación); y (iv) tu consentimiento cuando así se
              requiera.{' '}
              <em>[NOTA LEGAL: la normativa venezolana sobre protección de datos es limitada;
              la asesoría legal debe confirmar las bases aplicables y, si resulta pertinente,
              alinear con estándares de referencia como el GDPR para operaciones internacionales.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Quién puede acceder a los datos</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>
                <strong>Administración del condominio:</strong> ve únicamente la información de su
                propio condominio (residentes, unidades, cobros, visitas).
              </li>
              <li>
                <strong>Personal de seguridad:</strong> ve la información de pases, invitaciones y
                visitas necesaria para validar accesos en su portería.
              </li>
              <li>
                <strong>Personal de Vecindus:</strong> acceso restringido y limitado a lo necesario
                para operar, dar soporte y garantizar la seguridad de la plataforma.
              </li>
            </ul>
            <p className="text-gray-600 mt-4">
              <strong>No vendemos tus datos personales</strong> ni los compartimos con terceros con
              fines publicitarios.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Proveedores de servicios (encargados)</h2>
            <p className="text-gray-600 mb-4">
              Utilizamos proveedores terceros que procesan datos únicamente por nuestra cuenta:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>
                <strong>Resend</strong> — envío de correos transaccionales (verificación de correo,
                invitaciones, códigos de seguridad). No enviamos correos de marketing.
              </li>
              <li>
                <strong>OpenPay</strong> — procesador de pagos. Cuando se activen los pagos en
                línea (suscripciones o cobros), los datos de pago (por ejemplo, datos de tarjeta
                tokenizados) son tratados por OpenPay como procesador de terceros; nosotros no
                almacenamos números de tarjeta completos. El tratamiento que OpenPay realiza de
                tus datos de pago se rige por su propio aviso de privacidad, disponible en su
                sitio oficial.
              </li>
              <li>
                <strong>WhatsApp Business (Meta)</strong> — envío de códigos de verificación OTP
                por WhatsApp, cuando se utilice esta vía. El número de teléfono se utiliza
                exclusivamente para entregar el código de verificación; Meta Platforms Ireland/Inc.
                actúa como proveedor del canal de mensajería y procesa esos datos conforme a sus
                propios términos y políticas. No utilizamos el número para mensajes comerciales.
              </li>
              <li>
                <strong>Proveedor de SMS (futuro)</strong> — para el envío de códigos y avisos por
                mensajería, cuando se habilite. <em>[PERIODO POR DEFINIR]</em>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Conservación de datos</h2>
            <p className="text-gray-600 mb-4">
              <strong>Cuentas eliminadas:</strong> cuando una cuenta se elimina, aplicamos una
              eliminación lógica (soft-delete) por diseño: conservamos la dirección de correo como
              marcador de auditoría y para prevenir re-registros abusivos, sin conservar el resto
              del perfil activo.
            </p>
            <p className="text-gray-600">
              <strong>Registros de acceso y visitantes:</strong> aplicamos los siguientes períodos
              de retención, según la configuración vigente del servicio:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>
                <strong>Datos de visitantes (documentos de identificación):</strong> 30 días.
              </li>
              <li>
                <strong>Eventos de analítica de producto:</strong> 90 días (los agregados
                persisten sin datos personales identificables).
              </li>
              <li>
                <strong>Bitácoras de auditoría:</strong> 365 días (12 meses).
              </li>
            </ul>
            <p className="text-gray-600 mt-2">
              Una vez vencidos estos plazos, los datos se eliminan mediante procesos automáticos
              de purga periódica.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7.1 Tus derechos (ARCO)</h2>
            <p className="text-gray-600 mb-4">
              Puedes solicitar el ejercicio de tus derechos de <strong>acceso, rectificación,
              cancelación/eliminación y oposición</strong> sobre tus datos personales mediante una
              solicitud dirigida a{' '}
              <a href="mailto:info@vecindus.com" className="text-[#36CCD8] hover:text-[#2DB8C4] underline underline-offset-2">
                info@vecindus.com
              </a>
              , desde el correo verificado de tu cuenta. Verificaremos tu identidad antes de
              atender la solicitud y responderemos dentro de un plazo razonable conforme a la ley
              aplicable.{' '}
              <em>[NOTA LEGAL: definir plazos de respuesta y procedimiento formal.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Tus derechos</h2>
            <p className="text-gray-600 mb-4">
              Puedes ejercer, conforme a la ley aplicable, los siguientes derechos:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li><strong>Acceso:</strong> conocer qué datos tuyos tratamos.</li>
              <li>
                <strong>Rectificación:</strong> corregir datos inexactos. El cambio de correo se
                realiza mediante un flujo verificado (enlace al correo nuevo), para proteger la
                seguridad de tu cuenta.
              </li>
              <li><strong>Eliminación:</strong> solicitar la eliminación de tu cuenta y datos, sujetos
                a los períodos de retención descritos en la sección 7.</li>
              <li><strong>Oposición:</strong> oponerte a ciertos tratamientos conforme a la ley.</li>
            </ul>
            <p className="text-gray-600 mt-4">
              Para ejercer estos derechos, escríbenos a{' '}
              <a href="mailto:privacidad@vecindus.com" className="text-[#36CCD8] hover:text-[#2DB8C4] underline underline-offset-2">
                privacidad@vecindus.com
              </a>{' '}
              desde el correo verificado de tu cuenta. Los residentes también pueden dirigirse a la
              administración de su condominio, como responsable de los datos de la comunidad.
              <em> [NOTA LEGAL: definir plazos de respuesta y procedimiento formal.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Menores de edad</h2>
            <p className="text-gray-600">
              La plataforma no está dirigida a menores de edad y no recopilamos intencionalmente
              datos de menores. Las cuentas son creadas por adultos; cualquier registro de menores
              depende exclusivamente de los condominios y sus administraciones.{' '}
              <em>[NOTA LEGAL: fijar edad mínima (p. ej. 18 años) en los Términos.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Medidas de seguridad</h2>
            <p className="text-gray-600 mb-4">Aplicamos medidas técnicas y organizativas razonables, entre ellas:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Contraseñas almacenadas únicamente como hash con bcrypt.</li>
              <li>Tokens de un solo uso almacenados hasheados, con expiración limitada.</li>
              <li>Enlaces de verificación de correo con vigencia de 24 horas.</li>
              <li>Códigos OTP de 6 dígitos con expiración de 10 minutos.</li>
              <li>Eliminación lógica (soft-delete) de cuentas para auditoría y seguridad.</li>
            </ul>
            <p className="text-gray-600 mt-4">
              Ningún sistema es completamente seguro; en caso de un incidente que afecte datos
              personales, lo notificaremos a los afectados y autoridades conforme a la ley
              aplicable. <em>[NOTA LEGAL: definir política de notificación de incidentes.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Transferencias internacionales</h2>
            <p className="text-gray-600">
              Los proveedores de servicios (por ejemplo, infraestructura en la nube y envío de
              correo) pueden operar fuera de Venezuela, lo que implica transferencias
              internacionales de datos. Adoptamos medidas contractuales y técnicas razonables para
              proteger dichos datos. <em>[NOTA LEGAL: identificar proveedores de infraestructura y
              mecanismos de transferencia aplicables.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">12. Cookies</h2>
            <p className="text-gray-600">
              Utilizamos únicamente las cookies y almacenamientos locales estrictamente necesarios
              para mantener tu sesión iniciada y el funcionamiento del servicio. No utilizamos
              cookies publicitarias ni de rastreo de terceros.{' '}
              <em>[NOTA LEGAL: elaborar política de cookies detallada si se incorporan otras
              categorías.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">13. Cambios en esta política</h2>
            <p className="text-gray-600">
              Publicaremos en esta página cualquier actualización con la fecha de vigencia
              correspondiente; los cambios sustanciales se notificarán dentro de la plataforma o
              por correo con antelación razonable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">14. Contacto y responsable de protección de datos</h2>
            <p className="text-gray-600 mb-4">
              Para preguntas sobre esta Política o el tratamiento de tus datos:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Correo: privacidad@vecindus.com</li>
              <li>Contacto: info@vecindus.com</li>
              <li>
                Oficial / Delegado de Protección de Datos:{' '}
                <em>[PERIODO POR DEFINIR]</em>{' '}
                <em>[NOTA LEGAL: designar responsable y publicar sus datos de contacto.]</em>
              </li>
            </ul>
          </section>

          <p className="text-sm text-gray-400 mt-12">
            Última actualización: Septiembre 2026 — Borrador pendiente de revisión legal.
          </p>
        </div>
      </main>
    </div>
  );
}
